export enum DocumentEventCode {
  Uploaded = 'DOCUMENT_UPLOADED',
  Assigned = 'DOCUMENT_ASSIGNED',
  Completed = 'DOCUMENT_COMPLETED',
  Downloaded = 'DOCUMENT_DOWNLOADED',
}
